import { navigateToPage, getHomepageUrl } from '../../../../../shared/scripts/ui_utils/ClientUtils.ts';
import { AnalyticEventCategory, AnalyticEventType } from '../../../../../../shared/entity_datas/EntityDatas.ts';
import { StorageWrapper } from '../../../../../shared/scripts/StorageWrapper.ts';
import { UIUtilsEjsVariables } from '../../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { CA } from '../../../../../shared/scripts/analytics/Analytics.ts';
import { UITopNotificationType } from '../../../../../shared/scripts/notifications/UINotificationController.ts';
import { UIMGameMode } from '../../../UIMGameModeController.ts';
import { UIMNotificationView } from '../../../notifications/UIMNotificationView.ts';
import { setElementOnClick } from '../../../../../shared/scripts/ui_utils/DomUtils.ts';
export class UIMMenuGameOrientationController {
    setClickActionToButton(button, shouldEnablePortrait) {
        button.classList.add('inactive');
        setElementOnClick(button, ()=>{
            this.showNotification(shouldEnablePortrait);
            const eventData = {
                type: AnalyticEventType.ClickedChangeMobileOrientation,
                category: AnalyticEventCategory.MobileAnalytics,
                stringValue: 'MENU',
                floatValue: shouldEnablePortrait ? UIMGameMode.PORTRAIT : UIMGameMode.LANDSCAPE
            };
            void CA.sendAnalyticEvent(eventData);
            UIMMenuGameOrientationController.togglePortraitMode(shouldEnablePortrait);
        });
    }
    static togglePortraitMode(shouldEnablePortrait) {
        StorageWrapper.setPortraitGamePlayEnabled(shouldEnablePortrait);
        setTimeout(()=>{
            navigateToPage(getHomepageUrl());
        }, 100);
    }
    // eslint-disable-next-line class-methods-use-this
    showNotification(isPortrait) {
        new UIMNotificationView({
            key: 'strings:roomPage.notifications.changedGameOrientation',
            options: {
                orientation: isPortrait ? 'portrait' : 'landscape'
            }
        }, UITopNotificationType.Information);
    }
    constructor(){
        const portraitToggle = document.getElementById('m-menu-mode-portrait');
        const landscapeToggle = document.getElementById('m-menu-mode-landscape');
        if (landscapeToggle == undefined || portraitToggle == undefined) return;
        if (UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) this.setClickActionToButton(landscapeToggle, false);
        else this.setClickActionToButton(portraitToggle, true);
    }
}
